export default "__VITE_ASSET__reRwV9qH__"